export function coerceToDate(value: unknown): Date | null {
    if (value == null || value === '') return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    if (typeof value === 'object' && typeof (value as { toDate?: () => Date }).toDate === 'function') {
        const date = (value as { toDate: () => Date }).toDate();
        return isNaN(date.getTime()) ? null : date;
    }
    if (typeof value === 'string') {
        const ddMmYyyy = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (ddMmYyyy) {
            return new Date(+ddMmYyyy[3], +ddMmYyyy[2] - 1, +ddMmYyyy[1]);
        }
        const parsed = new Date(value);
        return isNaN(parsed.getTime()) ? null : parsed;
    }
    const parsed = new Date(value as string | number);
    return isNaN(parsed.getTime()) ? null : parsed;
}

export function getAge(birthDate: string) {
    const today = new Date();
    const birthDay = coerceToDate(birthDate) ?? new Date(birthDate);
    let age = today.getFullYear() - birthDay.getFullYear();
    const month = today.getMonth() - birthDay.getMonth();

    if(month < 0 || (month === 0 && today.getDate() < birthDay.getDate())) {
        age --;
    }

    return age;
}